webpackJsonp([1],{

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1616)
  __webpack_require__(1617)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1601),
  /* template */
  __webpack_require__(1657),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTreePicker',
  props: {
    value: { type: Array, required: false },
    spaceIds: { type: Array, required: false },
    expanded: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      search: null,
      selected: [],
      expandAll: false
    };
  },
  mounted: function mounted() {
    if (this.expanded) {
      this.expandAll = true;
      this.$refs.producttree.updateAll(this.expandAll);
    }
  },

  watch: {
    selected: function selected() {
      var products = this.selected.filter(function (item) {
        return String(item).indexOf('-') === -1;
      });
      this.$emit('input', products);
    },
    expandAll: function expandAll() {
      this.$refs.producttree.updateAll(this.expandAll);
    }
  },
  methods: {
    filter: function filter(item, search, textKey) {
      var val = item[textKey];
      return search && val && val.toLowerCase().indexOf(search.toLowerCase()) > -1;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['spaces', 'getProducts', 'getPractitionerById']), {
    filteredSpaces: function filteredSpaces() {
      var _this = this;

      if (this.spaceIds && this.spaceIds.length > 0) {
        return this.spaces.filter(function (space) {
          return _this.spaceIds.indexOf(space.id) !== -1;
        });
      }
      return this.spaces;
    },
    items: function items() {
      var _this2 = this;

      return this.filteredSpaces.map(function (item) {
        var r = Math.random().toString();
        var members = [];
        if (item.members) {
          members = item.members;
        }
        return {
          id: item.id + '-' + r,
          name: item.title,
          children: members.map(function (practitionerId) {
            var practitioner = _this2.getPractitionerById(practitionerId);
            return {
              id: item.id + '-' + practitioner.id,
              name: practitioner.full_name,
              type: 'practitioner',
              active: practitioner.is_active,
              archived: practitioner.archived,
              children: _this2.getProducts(practitionerId, item.id).map(function (item) {
                return {
                  id: item.id,
                  name: item.title,
                  owner_name: item.owner_name,
                  locations: item.locations
                };
              })
            };
          })
        };
      });
    }
  })
});

/***/ }),

/***/ 1567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpaceAndLocationFilter',
  props: {
    cta: { type: String, default: 'Filters' },
    ctaIcon: { type: String, default: 'filter_list' }
  },
  data: function data() {
    return {
      menu: false,
      selected: []
    };
  },

  methods: {
    emitSelected: function emitSelected(selected) {
      var spaces = [];
      var locations = [];
      selected.forEach(function (item) {
        if (item.startsWith && item.startsWith('space-')) {
          spaces.push(parseInt(item.substring(6)));
        } else {
          locations.push(item);
        }
      });
      this.$emit('input', { spaces: spaces, locations: locations });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['lookups']), {
    spaces: function spaces() {
      if (this.lookups && this.lookups.spaces) {
        var spaces = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.lookups.spaces);
        return spaces.map(function (space) {
          return {
            id: 'space-' + space.id,
            name: space.title,
            children: space.locations
          };
        });
      }
      return [];
    },
    items: function items() {
      return [{
        id: 1,
        name: 'Applications :',
        children: [{ id: 2, name: 'Calendar : app' }, { id: 3, name: 'Chrome : app' }, { id: 4, name: 'Webstorm : app' }]
      }];
    }
  })
});

/***/ }),

/***/ 1568:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1566),
  /* template */
  __webpack_require__(1570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1567),
  /* template */
  __webpack_require__(1571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1570:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "prepend-icon": "search",
      "label": "Search"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.search = ''
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.expandAll = !_vm.expandAll
      }
    }
  }, [_c('v-icon', [_vm._v("library_add")])], 1)], 1), _vm._v(" "), _c('v-treeview', {
    ref: "producttree",
    attrs: {
      "selectable": "",
      "open-on-click": "",
      "multiple-active": "",
      "search": _vm.search,
      "filter": _vm.filter,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n      " + _vm._s(item.name) + "\n      "), (item.archived === true) ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "warning"
          }
        }, [_vm._v("archived")]) : _vm._e(), _vm._v(" "), (item.active === false) ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "warning"
          }
        }, [_vm._v("deactivated")]) : _vm._e()]
      }
    }, {
      key: "append",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.locations), function(location) {
          return _c('v-chip', {
            key: ((item.id) + "-" + (location.id)),
            staticClass: "v-chip--x-small",
            attrs: {
              "outline": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("place")]), _vm._v("\n          " + _vm._s(location.name))], 1)
        })
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1571:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 200,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "color": "info",
            "right": "",
            "overlap": ""
          },
          scopedSlots: _vm._u([{
            key: "badge",
            fn: function() {
              return [(_vm.selected && _vm.selected.length > 0) ? _c('span', {
                domProps: {
                  "textContent": _vm._s(_vm.selected.length)
                }
              }) : _vm._e()]
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" "), _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "dark": "",
            "outline": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-2"
        }, [_vm._v(_vm._s(_vm.ctaIcon))]), _vm._v("\n          " + _vm._s(_vm.cta) + "\n        ")], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-system-bar', [_vm._v("\n        Filter results\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-treeview', {
    attrs: {
      "dense": "",
      "selectable": "",
      "selection-type": "independent",
      "items": _vm.spaces
    },
    on: {
      "input": _vm.emitSelected
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddMember',
  data: function data() {
    return {
      active: 0
    };
  },

  methods: {
    next: function next() {
      this.active++;
    }
  }
});

/***/ }),

/***/ 1573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Become',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$appointmentguru.resource('auth.become').id('become').list();
  },

  computed: {
    becomeUsers: function becomeUsers() {
      var req = this.$store.getters.getRequestById('become', true);
      return this.getObjectPath(req, 'result.data', []);
    },
    becomeRequest: function becomeRequest() {
      return this.$store.getters.getRequestById('do-become', true);
    },
    becomeRequestStatus: function becomeRequestStatus() {
      return this.becomeRequest.status;
    }
  },
  watch: {
    becomeRequestStatus: function becomeRequestStatus() {
      if (this.becomeRequestStatus === 200) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.becomeRequest.result.data));
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_constants__["i" /* LOGIN */], this.becomeRequest.result.data);
        window.alert('You are logged in as them now');
      }
    }
  },
  methods: {
    login: function login(userId) {
      var data = { become_id: userId };
      console.log(data);
      this.$appointmentguru.resource('auth.become').id('do-become').create(data);
    }
  }
});

/***/ }),

/***/ 1579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_client_ClientList__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BulkAddClients',
  components: { ClientList: __WEBPACK_IMPORTED_MODULE_1__components_client_ClientList___default.a },
  data: function data() {
    return {
      raw: 'Johannes Heyns\t769483326\tfheyns@heynscor.co.za\nJurie van Dyk\t824535846\tjurievandyk01@gmail.com',
      items: [],
      splitter: '\t'
    };
  },

  watch: {
    raw: function raw() {
      this.parseText(this.raw);
    }
  },
  computed: {
    clients: function clients() {
      return this.$store.getters.clients;
    }
  },
  methods: {
    parseText: function parseText(raw) {
      var _this = this;

      var rows = raw.split('\n');
      this.items = [];
      var index = 0;
      this.items = rows.map(function (item) {
        index++;
        var bits = item.split(_this.splitter);
        var firstLast = _this.splitName(bits[0]);
        var phone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["b" /* format */])(_this.parsedNumber(bits[1]), 'International_plaintext');
        return {
          key: index,
          full_name: bits[0],
          first_name: firstLast[0],
          last_name: firstLast[1],
          phone_number: phone,
          email: bits[2].toLowerCase()
        };
      });
    },
    splitName: function splitName(fullName) {
      var firstName = '';
      var lastName = '';
      if (fullName) {
        firstName = fullName.split(' ', 1).pop();
        lastName = fullName.split(' ').splice(1).join(' ');
      }
      return [firstName, lastName];
    },
    parsedNumber: function parsedNumber(number) {
      var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ZA';

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["c" /* parse */])(number, countryCode);
    },
    isValidNumber: function isValidNumber() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["d" /* isValidNumber */])(this.parsedNumber)) {
        return 'Please enter a valid phone number';
      }
    },
    createAll: function createAll() {
      this.items.forEach(this.create);
    },
    create: function create(item) {
      var reqId = 'bulk-client-' + item.key;
      this.$appointmentguru.resource('practitioner.clients.new').id(reqId).create(item);
    },
    getRequest: function getRequest(item) {
      var reqId = 'bulk-client-' + item.key;
      return this.$store.getters.getRequestById(reqId, true);
    }
  }
});

/***/ }),

/***/ 1583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ZoomMakeOnline',
  props: {
    appointments: { type: Array, required: false }
  },
  data: function data() {
    return {
      reqId: 'integrations-list',
      connectReqId: 'integrations-connect-zoom'
    };
  },
  mounted: function mounted() {
    if (this.oAuthCode) {
      this.connectToZoom();
    }
  },

  computed: {
    oauthUrl: function oauthUrl() {
      return 'https://zoom.us/oauth/signin?client_id=3vVWc4sHSTWQkXJILK64A&redirect_uri=https%3A%2F%2Fdeploy-preview-30--app-next.netlify.com%2F%23%2Ftest&response_type=code';
    },
    integrations: function integrations() {
      var lookups = this.store.getters.lookups;
      if ('integrations' in lookups) {
        return lookups.find(function (integration) {
          return integration.title === 'Zoom';
        });
      }
      return null;
    },
    integrationsRequest: function integrationsRequest() {
      return this.store.getters.getRequestById(this.reqId, true);
    },
    oAuthCode: function oAuthCode() {
      var search = window.location.search;
      var bits = search.split('=');
      if (bits && bits.length === 2) {
        return bits[1];
      }
      return null;
    }
  },
  methods: {
    getIntegrations: function getIntegrations() {
      this.$appointmentguru.resource('practitioner.integrations').list();
    },
    connectToZoom: function connectToZoom() {
      var data = {
        auth_code: this.oAuthCode
      };
      console.log(data);
      this.$appointmentguru.resource('practitioner.integrations.zoom').id(this.connectReqId).create(data);
    }
  }
});

/***/ }),

/***/ 1585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AsyncActionList',
  props: {
    objectId: {
      type: String,
      description: 'The objectID to listen for events on'
    }
  },
  computed: {
    timeline: function timeline() {
      return this.$store.getters.getAsyncMessagesById('foo');
    }
  }
});

/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_actions_InviteMember_index_vue__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_actions_InviteMember_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_actions_InviteMember_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_ProductTreePicker_vue__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_ProductTreePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pickers_ProductTreePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_SetClient__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_appointment_SetClient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_appointment_SetClient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lists_AsyncActionList__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lists_AsyncActionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_lists_AsyncActionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PhoneNumberInput__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PhoneNumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PhoneNumberInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_client_BulkAdd__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_client_BulkAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_client_BulkAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_Zoom__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_Zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_forms_Zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_cards_SmallAppointmentCard_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_cards_SmallAppointmentCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_cards_SmallAppointmentCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_unibox_SendTemplate__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_unibox_SendTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_unibox_SendTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_auth_Become__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_auth_Become___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_auth_Become__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_appointment_actions_CloneAppointment_vue__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_appointment_actions_CloneAppointment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_appointment_actions_CloneAppointment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pickers_ProductSheet__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pickers_ProductSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pickers_ProductSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pickers_SpaceAndLocationPicker__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pickers_SpaceAndLocationPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pickers_SpaceAndLocationPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_appointment_edit_AppointmentPriceDetails_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_appointment_edit_AppointmentPriceDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_appointment_edit_AppointmentPriceDetails_vue__);
























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TestPage',
  components: {
    Become: __WEBPACK_IMPORTED_MODULE_11__components_auth_Become___default.a,
    BulkAdd: __WEBPACK_IMPORTED_MODULE_7__components_client_BulkAdd___default.a,
    InviteMember: __WEBPACK_IMPORTED_MODULE_2__components_actions_InviteMember_index_vue___default.a,
    SpaceAndLocationPicker: __WEBPACK_IMPORTED_MODULE_15__components_pickers_SpaceAndLocationPicker___default.a,
    PhoneNumberInput: __WEBPACK_IMPORTED_MODULE_6__components_PhoneNumberInput___default.a,
    AsyncActionList: __WEBPACK_IMPORTED_MODULE_5__components_lists_AsyncActionList___default.a,
    SendTemplate: __WEBPACK_IMPORTED_MODULE_10__components_unibox_SendTemplate___default.a,
    ZoomIntegration: __WEBPACK_IMPORTED_MODULE_8__components_forms_Zoom___default.a,
    SetClient: __WEBPACK_IMPORTED_MODULE_4__components_appointment_SetClient___default.a,
    AppointmentPriceDetails: __WEBPACK_IMPORTED_MODULE_16__components_appointment_edit_AppointmentPriceDetails_vue___default.a,
    SmallAppointmentCard: __WEBPACK_IMPORTED_MODULE_9__components_cards_SmallAppointmentCard_vue___default.a,
    ProductTreePicker: __WEBPACK_IMPORTED_MODULE_3__components_pickers_ProductTreePicker_vue___default.a,

    CloneAppointment: __WEBPACK_IMPORTED_MODULE_13__components_appointment_actions_CloneAppointment_vue___default.a,
    ProductSheet: __WEBPACK_IMPORTED_MODULE_14__components_pickers_ProductSheet___default.a
  },
  props: {
    invoiceId: { type: Number, default: 0 }
  },
  data: function data() {
    return {
      code: null,
      process: null,
      permissionResult: false,
      appointmentId: null,
      actionName: 'foo',
      appts: [],
      selected: [],
      medicalaid: null,
      viz: true,
      client: {
        id: 1
      },
      practitioner: {
        id: 2138
      },
      requests: {
        invoice: 'invoice-detail-req-id',
        rel: {
          resource: 'ag.spaces.relationships',
          resourceId: '38521'
        },
        appt: {
          resource: 'ag.appointments'
        }
      },
      clientInfo: {
        ip: null,
        data: {}
      },
      phone: '‭+573209276694‬',
      touch: 1
    };
  },
  mounted: function mounted() {
    this.getAppointmentsInRange();
    if (this.practitioners) {
      this.practitioner = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.practitioners)[1];
    }
  },

  computed: {
    appointments: function appointments() {
      return this.$store.getters.appointments;
    },
    appointment: function appointment() {
      if (this.appointments && this.appointments.length > 0) {
        var index = Math.round(Math.random() * this.appointments.length);
        return this.appointments[index];
      }
    },
    appointmentDetail: function appointmentDetail() {
      return this.getObjectPath(this.requests, 'appt.result', null);
    },
    practitioners: function practitioners() {
      return this.$store.getters.lookups.practitioners;
    },
    clients: function clients() {
      return this.$store.getters.clients.slice(0, 3);
    },
    appointmentsReq: function appointmentsReq() {
      var req = this.$store.getters.getRequestById(__WEBPACK_IMPORTED_MODULE_1__store_constants__["c" /* LIST_APPOINTMENTS_IN_RANGE_REQ */], true);
      return req;
    },
    invoice: function invoice() {
      var req = this.$store.getters.getRequestById(this.requests.invoice, false);
      if (req.result) {
        return req.result.data;
      }
      return {};
    }
  },
  watch: {
    invoiceId: function invoiceId() {
      this.getInvoice();
    }
  },
  methods: {
    getRelationship: function getRelationship() {
      this.$request('get', this.requests.rel);
    },
    getAppointment: function getAppointment(id) {
      this.requests.appt.resourceId = id;
      this.$request('get', this.requests.appt);
    },
    getClientInfo: function getClientInfo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api.ipify.org?format=json').then(function (res) {
        var ip = res.data.ip;
        vm.clientInfo.ip = res.data.ip;
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api.clearip.io/ip/' + ip + '/json?apikey=yc757b5c92afdf1529102430eda36316').then(function (res) {
          vm.clientInfo.data = res.data;
        });
      });
    },
    setClient: function setClient(client) {
      this.client = client;
    },
    slackit: function slackit() {
      this.$communicationguru.resource('slack').list();
    },
    getInvoice: function getInvoice() {
      if (this.invoiceId && this.invoiceId > 0) {
        this.$invoiceguru.resource('invoices').id(this.requests.invoice).get(this.invoiceId);
      }
    },
    doUpgrade: function doUpgrade() {
      this.$invoiceguru.resource('upgrade').id('upgrade').create();
    }
  }
});

/***/ }),

/***/ 1605:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1555)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"BulkAdd.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1609:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1555)(true);
// imports


// module
exports.push([module.i, ".horizontal-scrolling-wrapper{display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow-x:auto}.horizontal-scrolling-wrapper .card{-ms-flex:0 0 auto;flex:0 0 auto;min-width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/pages/TestPage.vue"],"names":[],"mappings":"AACA,8BACE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,iBAAkB,AACtB,eAAiB,CAClB,AACD,oCACE,kBAAmB,AACf,cAAe,AACnB,cAAc,CACf","file":"TestPage.vue","sourcesContent":["\n.horizontal-scrolling-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  overflow-x: auto;\n}\n.horizontal-scrolling-wrapper .card {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  min-width:100%\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1610:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1555)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TestPage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1611:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1555)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Become.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1612:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1605);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1556)("593bd896", content, true, {});

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1556)("4f69c6a9", content, true, {});

/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1610);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1556)("50a01988", content, true, {});

/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1611);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1556)("4e78985a", content, true, {});

/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1572),
  /* template */
  __webpack_require__(1655),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1618)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1573),
  /* template */
  __webpack_require__(1661),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1625:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1612)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1579),
  /* template */
  __webpack_require__(1648),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1583),
  /* template */
  __webpack_require__(1675),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1630:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1585),
  /* template */
  __webpack_require__(1643),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-timeline', {
    attrs: {
      "dense": "",
      "clipped": ""
    }
  }, [_c('v-slide-x-transition', {
    attrs: {
      "group": ""
    }
  }, _vm._l((_vm.timeline), function(event, index) {
    return _c('v-timeline-item', {
      key: event.time,
      staticClass: "mb-0 pb-0",
      attrs: {
        "icon": event.icon,
        "color": event.color || 'pink',
        "small": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-content', [(event.message) ? _c('v-list-tile-title', [_vm._v(_vm._s(event.message))]) : _vm._e(), _vm._v(" "), (event.time) ? _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(_vm.dateformat(event.time.replace('%20', '+'), 'HH:mm:ss')) + "\n            ")]) : _vm._e()], 1)], 1)], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-flex'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "20",
      "solo": ""
    },
    model: {
      value: (_vm.raw),
      callback: function($$v) {
        _vm.raw = $$v
      },
      expression: "raw"
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.clients.length) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_vm._v("\n              Current client count\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.items.length) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_vm._v("\n              About to add\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.getClients()
      }
    }
  }, [_vm._v("Reload clients")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.createAll
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('client-list', {
    staticClass: "mt-3"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs1": ""
      }
    }, [(_vm.getRequest(item).loading) ? _c('v-progress-circular', {
      staticClass: "mt-2",
      attrs: {
        "color": "amber",
        "size": 30,
        "indeterminate": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getRequest(item).status === 201) ? _c('v-icon', {
      staticClass: "mt-3",
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_cirle")]) : _vm._e(), _vm._v(" "), (_vm.getRequest(item).status > 299) ? _c('v-icon', {
      staticClass: "mt-3",
      attrs: {
        "color": "red"
      }
    }, [_vm._v("warning")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "full name"
      },
      model: {
        value: (item.full_name),
        callback: function($$v) {
          _vm.$set(item, "full_name", $$v)
        },
        expression: "item.full_name"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "phone"
      },
      model: {
        value: (item.phone_number),
        callback: function($$v) {
          _vm.$set(item, "phone_number", $$v)
        },
        expression: "item.phone_number"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "email"
      },
      model: {
        value: (item.email),
        callback: function($$v) {
          _vm.$set(item, "email", $$v)
        },
        expression: "item.email"
      }
    })], 1)], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline",
    attrs: {
      "touchless": ""
    }
  }, [_vm._v("\n    Add a new member to your team\n  ")]), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "ag-input-xl",
    attrs: {
      "outline": "",
      "label": "Email address",
      "type": "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Phone",
      "type": "phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "registration number"
    }
  }), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "member"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "owner"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("\n      Next\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1657:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('product-tree-picker', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.selected && _vm.selected.length > 0) ? _c('pre', {
    staticClass: "caption grey lighten-4 pa-3",
    domProps: {
      "textContent": _vm._s(_vm.selected.join(','))
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "width": "600"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n      Upgrade your account\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-5 my-3"
  }, [_c('v-card-title', {
    staticClass: "title blue-grey darken-4 white--text"
  }, [_vm._v("\n              STARTER\n              "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "white--text",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("R300")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('ul', [_c('li', [_vm._v("Best effort support")])]), _vm._v(" "), _c('ul', [_c('li', [_c('s', [_vm._v("SMS Notifications")])])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": ""
    }
  }, [_vm._v("Select Starter")])], 1), _vm._v(" "), _c('v-card-text', [_c('small', [_vm._v("* Not eligible for promotions, discounts and special offers")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-20 pb-3",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title black white--text"
  }, [_vm._v("\n              PRO\n              "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "white--text",
    attrs: {
      "color": "success"
    }
  }, [_vm._v("R500")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-3"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('div', [_c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Priority support")], 1), _vm._v(" "), _c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" SMS notifications")], 1)])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": ""
    }
  }, [_vm._v("Select Pro")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "my-3 blue-grey--text"
  }, [_c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Cancel anytime")], 1), _vm._v(" "), _c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Change your package whenever you like")], 1)])], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Appointment ID"
    },
    model: {
      value: (_vm.appointmentId),
      callback: function($$v) {
        _vm.appointmentId = $$v
      },
      expression: "appointmentId"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.appt.loading
    },
    on: {
      "click": function($event) {
        return _vm.getAppointment(_vm.appointmentId)
      }
    }
  }, [_vm._v("fetch")]), _vm._v(" "), _c('v-system-bar', {
    staticClass: "overline",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n    Your appointment\n  ")]), _vm._v(" "), (_vm.appointmentDetail) ? _c('small-appointment-card', {
    attrs: {
      "fetch": ""
    },
    model: {
      value: (_vm.appointmentDetail),
      callback: function($$v) {
        _vm.appointmentDetail = $$v
      },
      expression: "appointmentDetail"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("fetchAppointments", [181139, 169790, 181766])
      }
    }
  }, [_vm._v("\n      Fetch mutation")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.getAppointmentsInRange
    }
  }, [_vm._v("Fetch appts")]), _vm._v("\n    Permission: " + _vm._s(_vm.permissionResult) + " |\n    "), _c('v-text-field', {
    attrs: {
      "label": "action name"
    },
    model: {
      value: (_vm.actionName),
      callback: function($$v) {
        _vm.actionName = $$v
      },
      expression: "actionName"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.permissionResult = _vm.hasPermission("foo", 887)
      }
    }
  }, [_vm._v("Check")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.getClientInfo
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.clientInfo))])], 1), _vm._v(" "), _c('become')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1661:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "two-line": "",
      "avatar": ""
    }
  }, [_c('v-subheader', [_vm._v("Become someone else")]), _vm._v(" "), _vm._l((_vm.becomeUsers), function(user) {
    return [_c('v-list-tile', {
      key: ("user=" + (user.id))
    }, [_c('v-list-tile-avatar', [(user.profile) ? _c('img', {
      attrs: {
        "src": user.profile
      }
    }) : _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v(_vm._s(user.full_name))]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.login(user.id)
        }
      }
    }, [_vm._v("Become")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: user.id
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1675:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.oauthUrl
    }
  }, [_vm._v("Connect Zoom")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.oAuthCode
    },
    on: {
      "click": _vm.connectToZoom
    }
  }, [_vm._v("Authenticate")]), _vm._v("\n    " + _vm._s(_vm.oAuthCode) + "\n\n")], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.36e2d44c85b175e5e62e.js